import { useMediaQuery, useTheme } from "@mui/material";

export default function useDesktopSize() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("md"));
}
